import { HttpClient } from "@angular/common/http";
import { Injectable, Inject } from "@angular/core";
import { FilterInput, ProductInput } from "../../inputs";
import { ProductsListResponse } from "../../models";
import { HttpService } from "./http.service";
import { Observable } from "rxjs";
import { DealsResponse } from "../../inputs/deal.input";
import { Deal, GetAllDeals } from "../../models/admin/deals.model";

@Injectable({
  providedIn: 'root'
})
export class DealService extends HttpService<
  ProductInput | FilterInput, ProductsListResponse | DealsResponse | GetAllDeals
> {
  constructor(
    httpClient: HttpClient,
    @Inject('API_URL') apiUrl: string,
    @Inject('API_VERSION') apiVersion: string) {
    super(httpClient, apiUrl, apiVersion, 'deal');
  }
   getDealProductsVarients(dealid,page = 1,random=''): Observable<ProductsListResponse> {
    return this.getAllPagedDeal(dealid+'/products?limit=20&random_string='+random, page) as Observable<ProductsListResponse>;
  }
   getDeals(page = 1): Observable<DealsResponse[]> {
    return this.getAll('active') as Observable<DealsResponse[]>;
  }
  getAllDeals(page = 1,limit = 10): Observable<GetAllDeals> {
    return this.getAllPaged('admin', page, '', limit) as Observable<GetAllDeals>;
  }
 
    findAllByName(text: string, page = 1): Observable<GetAllDeals> {
      const filter: FilterInput = {
        page: page,
        limit: 10,
        filters: {
          and: [['deal_translations.name', 'ILIKE', `%${text}%`]]
        }
      };
      return this.filterAllActionPagedAdmin(filter,'admin') as Observable<GetAllDeals>;
    }

  deletebyID(id: string): Observable<any> {
    return this.delete(id,);
  }
  getSingleDeal(dealId: number): Observable<Deal> {
      return this.getById(dealId,'admin') as Observable<Deal>;
    }

  createDeal(payload: any): Observable<any> {
    return this.create(payload);
  }

  updateDeal(dealId: number, payload: any): Observable<any> {
    return this.update(payload,'', dealId);
  }
changeDealStatus(dealId: number, payload: any): Observable<any> {
    return this.patch(dealId,payload);
  }
  getDealStats(): Observable<any> {
    return this.getAll('status-counts');
  }
   getSingleDealUser(dealId: number): Observable<Deal> {
      return this.getById(dealId) as Observable<Deal>;
    }
}